import React from "react"
import HeroSection from "../../Shared/HeroSection/HeroSection"
import { graphql, useStaticQuery } from "gatsby"
import Container from "../../Shared/Container/Container"
import Section from "../../Shared/Section/Section"
import Cards from "../../Shared/Cards/Cards"

import styles from "./Donate.module.css"

import HowItWorks from "./HowItWorks/HowItWorks"
import FlexibleToYourNeeds from "./FlexibleToYourNeeds/FlexibleToYourNeeds"
import FixedFooter from "../../Shared/FixedFooter/FixedFooter"
import { routes } from "../../../config"

const Donate = () => {
  const data = useStaticQuery(graphql`
    query donateQuery {
      donateImg1: file(relativePath: { eq: "donate/donate1.png" }) {
        childImageSharp {
          fluid(quality: 100) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      donateImg2: file(relativePath: { eq: "donate/donate2.png" }) {
        childImageSharp {
          fluid(quality: 100) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      donateImg3: file(relativePath: { eq: "donate/donate3.png" }) {
        childImageSharp {
          fluid(quality: 100) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      exampleImg: file(relativePath: { eq: "donate/example.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 314, quality: 100) {
            ...GatsbyImageSharpFluid
          }
        }
      }
    }
  `)
  return (
    <div className={styles.donate}>
      <HeroSection
        preHeading={"DONATE"}
        heading={"Employee led philanthropy"}
        content={<> Empower every one of your people to become citizen <br/> philanthropists and create real change</>}
        imageCards={[
          { alt: "People", src: data.donateImg1.childImageSharp.fluid, title: "People" },
          { alt: "and", src: data.donateImg2.childImageSharp.fluid, title: "and" },
          { alt: "Planet", src: data.donateImg3.childImageSharp.fluid, title: "Planet" },
        ]}/>
      <FixedFooter type={"how-it-works"}/>
      <Container>
        <Section heading={"How we help"}>
          <Cards classNames={["checkMarks"]} cards={[
            {
              header: "Employee led philanthropy",
              content: <p>
                Involve every employee in your philanthropic work through choice and tieing it to their health,
                development and culture.
              </p>,
            },
            {
              header: "Proud Employees",
              content: <p>
                When you give your people a choice in the impact they can make, you bring a new group of empowered,
                proud employees
              </p>,
            },
            {
              header: "Collective Impact",
              content: <p>
                See and celebrate your collective impact across your organisation and bulid something everyone can get
                behind
              </p>,
            },
          ]}/>

        </Section>
        <Section heading={"How it works"}>
          <HowItWorks/>
        </Section>
        <Section heading={"Flexible to your needs"}>
          <FlexibleToYourNeeds/>
        </Section>
        <Section heading={"Cultural Currency in three steps"}>
          <Cards cards={[
            {
              header: "Reward",
              content: "Promote the things that matter to your people and planet. and build a pride in your company",
              link: "/reward",
              icon: "reward",
            },
            {
              header: "Recognise",
              content: "Create a recognition rich work environment with free flowing feedback",
              link: "/recognise",
              icon: "recognise",
            },
            {
              header: "Donate",
              content: "Donate your Cultural Currency to causes your employees care about and make your giving go further",
              link: routes.slack,
              isOuterLink: true,
              icon: "donate",
              buttonText: "Get Started",
            },
          ]}/>
        </Section>
      </Container>
    </div>
  )
}


export default Donate